const MEDIA_API_URL_PATTERN = /\/api\/media\/\d+/i;
const MEDIA_PUBLIC_PATH_PATTERN = /^\/media\/\d+/i;

export function isMediaDownloadUrl(text: string): boolean {
  const value = text.trim();
  if (!value) return false;
  return (
    /^https?:\/\//i.test(value) ||
    MEDIA_API_URL_PATTERN.test(value) ||
    MEDIA_PUBLIC_PATH_PATTERN.test(value)
  );
}

export function basenameFromFileUrl(fileUrl?: string): string | null {
  if (!fileUrl) return null;
  const segment = fileUrl.split('/').filter(Boolean).pop();
  if (!segment) return null;
  try {
    return decodeURIComponent(segment);
  } catch {
    return segment;
  }
}

const DOCUMENT_CAPTION_DEFAULTS = new Set([
  'Documento enviado pelo atendente',
  'documento.pdf',
]);

/**
 * Caption to show under the document icon (user-written text only).
 */
export function getDocumentDisplayCaption(
  messageText?: string,
  fileUrl?: string
): string | null {
  const raw = (messageText ?? '').trim();
  if (!raw || isMediaDownloadUrl(raw)) return null;

  const fileBase = basenameFromFileUrl(fileUrl);
  if (fileBase && raw === fileBase) return null;
  if (DOCUMENT_CAPTION_DEFAULTS.has(raw)) return null;

  return raw;
}

/**
 * Filename used when downloading the attachment.
 */
export function getDocumentDownloadName(
  messageText?: string,
  fileUrl?: string,
  originalName?: string
): string {
  const fromMetadata = (originalName ?? '').trim();
  if (fromMetadata) return fromMetadata;

  const fileBase = basenameFromFileUrl(fileUrl);
  const raw = (messageText ?? '').trim();
  if (
    raw &&
    !isMediaDownloadUrl(raw) &&
    raw !== fileBase &&
    !DOCUMENT_CAPTION_DEFAULTS.has(raw)
  ) {
    return raw;
  }

  if (fileBase) return fileBase;

  return 'documento.pdf';
}
